// Damages — incident records linked to vehicles, optionally to a specific rental/customer.
//
// TWO INDEPENDENT TRACKS:
//   1. status (payment/legal flow):
//      reported → charging → paid | disputed | insurance | waived (dismissed)
//   2. repaired (boolean — physical state):
//      false → still on the car (shown on next rental's check-in as pre-existing)
//      true  → physically fixed (no longer visible)
//
// A damage can be "paid" but not "repaired" (customer paid today, repair next week).
// Only `repaired: true` removes it from the pre-existing-damages list on check-in.
//
// Severity ladder:
//   minor    — cosmetic, < €100
//   moderate — visible damage, €100–500
//   major    — significant repair, > €500

export const DAMAGE_TYPES = [
  { id: 'scratch',    label: 'Scratch',          icon: '🔸' },
  { id: 'dent',       label: 'Dent',             icon: '🟠' },
  { id: 'mechanical', label: 'Mechanical',       icon: '⚙️' },
  { id: 'interior',   label: 'Interior',         icon: '🪑' },
  { id: 'tyre',       label: 'Tyre / Wheel',     icon: '🛞' },
  { id: 'windshield', label: 'Glass / Mirror',   icon: '🪟' },
  { id: 'paint',      label: 'Paint',            icon: '🎨' },
  { id: 'theft',      label: 'Theft / Missing',  icon: '🚨' },
  { id: 'other',      label: 'Other',            icon: '⚠️' },
];

export const DAMAGE_LOCATIONS = [
  'Front bumper', 'Rear bumper',
  'Front-left fender', 'Front-right fender',
  'Rear-left fender', 'Rear-right fender',
  'Front-left door',  'Front-right door',
  'Rear-left door',   'Rear-right door',
  'Hood / Bonnet', 'Roof', 'Boot / Trunk',
  'Windshield', 'Rear window', 'Side mirror — left', 'Side mirror — right',
  'Wheel — front-left', 'Wheel — front-right', 'Wheel — rear-left', 'Wheel — rear-right',
  'Interior — seats', 'Interior — dashboard', 'Interior — carpet',
  'Engine bay', 'Underbody', 'Lights', 'Other',
];

export const DAMAGE_SEVERITIES = [
  { id: 'minor',    label: 'Minor',    color: '#10b981' },
  { id: 'moderate', label: 'Moderate', color: '#f59e0b' },
  { id: 'major',    label: 'Major',    color: '#ef4444' },
];

// Payment / legal status — independent from physical repair state
export const DAMAGE_STATUSES = [
  { id: 'reported',  label: 'Reported',          color: '#64748b', bg: '#f1f5f9' },
  { id: 'charging',  label: 'Awaiting payment',  color: '#f59e0b', bg: '#fef3c7' },
  { id: 'disputed',  label: 'Disputed',          color: '#ef4444', bg: '#fee2e2' },
  { id: 'insurance', label: 'Insurance claim',   color: '#8b5cf6', bg: '#ede9fe' },
  { id: 'paid',      label: 'Paid',              color: '#10b981', bg: '#d1fae5' },
  { id: 'waived',    label: 'Waived / Absorbed', color: '#94a3b8', bg: '#f1f5f9' },
  // Legacy alias — same as 'paid' + 'repaired'. Kept so old records still render.
  { id: 'resolved',  label: 'Resolved',          color: '#10b981', bg: '#d1fae5' },
  { id: 'dismissed', label: 'Dismissed',         color: '#94a3b8', bg: '#f1f5f9' },
];

export const DAMAGE_PAID_BY = [
  { id: 'customer',  label: 'Customer'   },
  { id: 'insurance', label: 'Insurance'  },
  { id: 'absorbed',  label: 'Absorbed (waived)' },
  { id: 'unpaid',    label: 'Unpaid'     },
];

export const initialDamages = [
  {
    id: 'dmg-001',
    vid: 'klm147',
    rentalId: 'CNT-002',
    customerId: 'C-003',
    customerName: 'Andreas Petrou',
    type: 'dent',
    location: 'Front-left door',
    severity: 'moderate',
    description: 'Dent on the front-left door, customer says no recollection of impact. Found at return.',
    reportedDate: '2026-03-04',
    photos: [],
    estimatedCost: 280,
    finalCost: 280,
    status: 'paid',
    paidBy: 'customer',
    invoiceId: 'INV-0004',
    insuranceClaim: '',
    repaired: true,
    repairedDate: '2026-03-08',
    resolvedDate: '2026-03-05',
    notes: 'Customer agreed to charge after seeing photos. Body shop repaired 8 Mar.',
    reportedBy: 'u1',
    createdAt: '2026-03-04T10:30:00',
  },
  {
    id: 'dmg-002',
    vid: 'mzz099',
    rentalId: null,
    customerId: null,
    customerName: '',
    type: 'paint',
    location: 'Rear bumper',
    severity: 'minor',
    description: 'Light paint scuff on rear bumper. Origin unknown — likely parking incident on lot.',
    reportedDate: '2026-04-12',
    photos: [],
    estimatedCost: 80,
    finalCost: 0,
    status: 'waived',
    paidBy: 'absorbed',
    invoiceId: null,
    insuranceClaim: '',
    repaired: true,
    repairedDate: '2026-04-12',
    resolvedDate: '2026-04-12',
    notes: 'Minor — buffed out in-house.',
    reportedBy: 'u1',
    createdAt: '2026-04-12T16:00:00',
  },
];
